export default "__VITE_ASSET__DiKhydSy__"